import { render, staticRenderFns } from "./IconLeftCircle.vue?vue&type=template&id=20d4a86e"
import script from "./IconLeftCircle.vue?vue&type=script&lang=js"
export * from "./IconLeftCircle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports